import React, { Component } from 'react';
import _ from 'underscore';

class PinPad extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pin: []
        };
    }

    componentDidMount() {
        if (this.props.autoFocus)
            this.refs.input0.focus();
    }

    onKeyDown(index, e) {
        if (e.keyCode === 8) {
            e.preventDefault();
            let currentElement = this.refs[`input${index}`];
            let previousElement = this.refs[`input${index - 1}`];
            if (currentElement)
                currentElement.value = '';
            if (previousElement)
                previousElement.focus();

        }
    }
    onChange(index, eventArgs) {
        this.state.pin[index] = eventArgs.target.value;



        if (index < (this.props.strength - 1)) {
            let nextRef = `input${index + 1}`;
            let nextElement = this.refs[nextRef];
            nextElement.focus();
        } else if (index === (this.props.strength - 1)) {
            this.props.pinComplete(this.state.pin.join(''));
        }

    }

    componentDidUpdate(prevProps) {
        if (!prevProps.enabled && this.props.enabled && this.props.autoFocus)
            this.refs.input0.focus();
    }

    render() {
        return (
            <div>
                {
                    _(this.props.strength).times(function (n) {
                        let refName = `input${n}`;
                        return (
                            <input
                                className="form-control input-single pin mask"
                                key={refName}
                                type="tel"
                                maxLength='1'
                                ref={refName}
                                onChange={this.onChange.bind(this, n)}
                                onKeyDown={this.onKeyDown.bind(this, n)}
                                disabled={!this.props.enabled} />
                        );
                    }.bind(this))
                }
            </div>
        );
    }
}

export default PinPad;


// WEBPACK FOOTER //
// ./app/auth/components/pinPad.js